module.exports = __webpack_public_path__ + "img/walk.adc5a30e.png";